import { Input, InputGroup, InputGroupText } from 'reactstrap';
import { Search, X } from 'react-bootstrap-icons';
import './SearchInput.css';

const SearchInput = ({
    value,
    onChange,
    onClear,
    className = '',
    style = {},
    placeholder = "Search",
    noRounded = false
}) => {
    const handleClear = () => {
        if (onClear) {
            onClear();
        } else {
            // If no onClear handler provided, create a synthetic event with empty value
            onChange({ target: { value: '' } });
        }
    };

    return (
        <InputGroup className={`search-input-group ${noRounded ? 'no-rounded' : ''} ${className}`} style={style}>
            <InputGroupText className='search-input-icon'>
                <Search color='gray' />
            </InputGroupText>
            <Input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className="search-input-field"
            />
            {value && (
                <InputGroupText
                    onClick={handleClear}
                    className='search-input-clear'
                >
                    <X color='gray' />
                </InputGroupText>
            )}
        </InputGroup>
    );
};


export default SearchInput;
